const returnMonthlyAmount = (amount, paymentInterval) => {
    const monthlyAmount = paymentInterval === 'month' ? amount : amount / 12
    return monthlyAmount.toFixed(0)
}

const normalizePrice = (amount, currency) => {
    const price = Math.abs(amount) / 100
    if (!currency) {
        return price
    }
    return currency + price
}

export default {
    returnMonthlyAmount,
    normalizePrice
}
